import { render, staticRenderFns } from "./BetslipBetSingleB.vue?vue&type=template&id=6025365a&scoped=true"
import script from "./BetslipBetSingleB.vue?vue&type=script&lang=js"
export * from "./BetslipBetSingleB.vue?vue&type=script&lang=js"
import style0 from "./BetslipBetSingleB.vue?vue&type=style&index=0&id=6025365a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6025365a",
  null
  
)

export default component.exports